module.exports = __webpack_public_path__ + "static/media/planet-earth-first.6eb642e7.jpg";